import { TextField, makeStyles } from "@material-ui/core";
import React, { useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { updateQuestionSetting } from "../actions";
const useStyles = makeStyles((props) => ({
  root: {
    display: "block",
    fontSize: "calc(var(--font-size)*0.8)",
    color: "var(--question-color)",
    opacity: "var(--tf-opacity)",
    cursor: "text",
  },
  text: {
    width: "100% !important",
    "& .MuiInputBase-root input": {
      fontFamily: "var(--font-family)",
      color: "var(--question-color)",
      opacity: "var(--tf-opacity)",
      borderBottom: "unset",
      fontSize: "calc(var(--font-size)*0.8)",
      padding: "0",
    },
    "& .MuiInput-underline:after": {
      borderBottom: "unset",
    },
    "& .MuiInput-underline:before": {
      borderBottom: "unset",
    },
    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
      borderBottom: "unset",
    },
  },
}));
const TemplateHint = (props) => {
  const {questionId, currentLanguage, previewForm } = useSelector(
    (state) => ({
      questionId: state.question_checked,
      currentLanguage: state.form_settings.default_language,
      previewForm: state.previewForm
    })
  );
  const classes = useStyles(props);
  const [show, setShow] = useState(false);
  const dispatch = useDispatch();
  return (
    <>
        <TextField
          classes={{ root: classes.text }}
          value={props.hint}
          onChange={(e) => {
            dispatch(
              updateQuestionSetting(
                questionId,
                `hint::${currentLanguage}`,
                e.target.value
              )
            );
          }}
          autoFocus={show}
          onBlur={() => {
            setShow(false);
          }}
          disabled={previewForm && !show}
        />
    </>
  );
};

const mapStateToProps = (state, props) => {
  return {
    ...props,
    ...state.theme_config,
  };
};

export default connect(mapStateToProps)(TemplateHint);
